import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
var _excluded = ["data-testid", "data-cy", "className", "hintColor", "areaRef", "rowsMin", "rowsMax", "onMultirowChange", "onChange"];
import { PureComponent } from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledTextArea = /*#__PURE__*/styled.textarea.withConfig({
  componentId: "sc-1f6gqo7-0"
})(["\n  ", "\n"], function (_ref) {
  var hintColor = _ref.hintColor;
  return "\n    &::-webkit-input-placeholder {\n      color: ".concat(hintColor, ";\n    }\n    &:-moz-placeholder { /* Firefox 18- */\n      color: ").concat(hintColor, ";\n    }\n    &::-moz-placeholder {  /* Firefox 19+ */\n      color: ").concat(hintColor, ";\n    }\n    &:-ms-input-placeholder {\n      color: ").concat(hintColor, ";\n    }\n    &::placeholder {\n      color: ").concat(hintColor, ";\n    }\n  ");
});
var TextArea = /*#__PURE__*/function (_PureComponent) {
  _inherits(TextArea, _PureComponent);
  var _super = /*#__PURE__*/_createSuper(TextArea);
  function TextArea(props) {
    var _this;
    _classCallCheck(this, TextArea);
    _this = _super.call(this, props);
    _this.textAreaElement = null;
    _this.updateRows = function (textAreaElement) {
      var _this$props = _this.props,
        rowsMin = _this$props.rowsMin,
        rowsMax = _this$props.rowsMax;

      // reset rows value
      _this.setState({
        rows: rowsMin
      }, function () {
        // Get the computed styles for the element
        var computed = window.getComputedStyle(textAreaElement);
        var padding = parseInt(computed.getPropertyValue('padding-top'), 10) + parseInt(computed.getPropertyValue('padding-bottom'), 10);
        var lineHeight = parseInt(computed.getPropertyValue('line-height'), 10);

        // calculate new rows value based on scrollHeight
        var rows = (textAreaElement.scrollHeight - padding) / lineHeight;
        var newRows = rowsMax && rows > rowsMax ? rowsMax : rows;

        // update state only if necessary
        if (newRows !== _this.state.rows && newRows >= rowsMin) {
          _this.setState({
            rows: newRows
          });
        }
      });
    };
    _this.onChange = function (e) {
      var _this$props2 = _this.props,
        onChange = _this$props2.onChange,
        value = _this$props2.value;

      // if the value is not controlled, rows need to be recalculated on change
      if (typeof value === 'undefined') {
        e.persist();
        _this.updateRows(e.target);
      }
      if (onChange) {
        onChange(e);
      }
    };
    _this.assignRef = function (i) {
      var areaRef = _this.props.areaRef;
      if (areaRef && typeof areaRef === 'function') {
        areaRef(i);
      } else if (areaRef) {
        areaRef.current = i;
      }
      _this.textAreaElement = i;
    };
    _this.state = {
      rows: props.rowsMin
    };
    return _this;
  }
  _createClass(TextArea, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props3 = this.props,
        value = _this$props3.value,
        onMultirowChange = _this$props3.onMultirowChange;
      var rows = this.state.rows;
      if (prevProps.value !== value && this.textAreaElement) {
        this.updateRows(this.textAreaElement);
      }
      if (prevState.rows !== rows) {
        onMultirowChange(rows > 1);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        dataTestId = _this$props4['data-testid'],
        dataCy = _this$props4['data-cy'],
        className = _this$props4.className,
        hintColor = _this$props4.hintColor,
        areaRef = _this$props4.areaRef,
        rowsMin = _this$props4.rowsMin,
        rowsMax = _this$props4.rowsMax,
        onMultirowChange = _this$props4.onMultirowChange,
        onChange = _this$props4.onChange,
        baseTextAreaProps = _objectWithoutProperties(_this$props4, _excluded);
      var rows = this.state.rows;
      return (
        /*#__PURE__*/
        // @ts-expect-error (TODO: No overload matches this call)
        _jsx(StyledTextArea, _objectSpread({
          "data-testid": dataTestId,
          "data-cy": dataCy,
          className: className,
          hintColor: hintColor,
          rows: rows,
          ref: this.assignRef,
          onChange: this.onChange
        }, baseTextAreaProps))
      );
    }
  }]);
  return TextArea;
}(PureComponent);
export default TextArea;